export const _globalThis = typeof globalThis === "object" ? globalThis : global;
//# sourceMappingURL=platform.js.map